import React from 'react';
import { NextSeo } from 'next-seo';
import { Box } from '@chakra-ui/react';
import PrivacyPolicy from 'components/PrivacyPolicy';

const PrivacyPolicyPage = () => {
  return (
    <Box id="content">
      <NextSeo
        title="Privacy Policy"
        description="Try HeyLayer and start your NFT business or grow an existing one. Get more than NFT minting to manage every part of your business."
      />
      <PrivacyPolicy />
    </Box>
  );
};

export default PrivacyPolicyPage;
